import { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { useParams } from "react-router-dom";

import { useGetQuoteRequestDetails } from "api/queries/quotes/useGetQuoteRequestDetails";
import { ReactComponent as ImportIcon } from "assets/images/icons/Import.svg";
import { ReactComponent as TemplateIcon } from "assets/images/icons/TemplateIcon.svg";
import { QuotationFreightModeOption } from "types/Common";
import Badge from "components/v2/Badge/Badge";
import ReuseFormTemplate from "../ReuseTemplate/ReuseFormTemplate";
import QuotationConfirmDialog from "../ReuseTemplate/QuotationConfirmDialog";

interface ITopRowProps {
  freightModeOptions: QuotationFreightModeOption[];
  numberOfStops: number;
}
export default function TopRow(props: ITopRowProps) {
  const { freightModeOptions, numberOfStops } = props;
  const [showReuseFormModal, setShowReuseFormModal] = useState<boolean>(false);
  const [showQuotationConfirmModal, setShowQuotationConfirmModal] = useState<boolean>(false);
  const [referenceId, setReferenceId] = useState<string>("");

  const intl = useIntl();
  const id = useParams().id?.toUpperCase();
  const { data: quoteRequestDetails } = useGetQuoteRequestDetails({
    shipmentId: id!,
    options: {
      enabled: !!id,
      refetchOnMount: false,
    },
  });

  return (
    <>
      <ReuseFormTemplate
        freightModeOptions={freightModeOptions}
        isOpen={showReuseFormModal}
        close={() => {
          setShowReuseFormModal(false);
        }}
        setShowQuotationConfirmModal={setShowQuotationConfirmModal}
        setReferenceId={setReferenceId}
      />
      <QuotationConfirmDialog
        isOpen={showQuotationConfirmModal}
        close={() => {
          setShowQuotationConfirmModal(false);
        }}
        setShowReuseFormModal={setShowReuseFormModal}
        referenceId={referenceId}
      />
      {numberOfStops > 2 && (
        <div className="mx-lg mt-xl">
          <Badge
            type="category-badge"
            color="purple"
            size="md"
            label={
              <div>
                <FormattedMessage id="new-request.schedule.multistop" defaultMessage="Multi-stop" />:
                <span className="font-regular">
                  {" "}
                  {numberOfStops} <FormattedMessage id="general.stops" defaultMessage="Stops" />
                </span>
              </div>
            }
          />
        </div>
      )}
      <div className="px-4 d-flex justify-content-between align-items-center">
        <h3 className="pt-16 mb-3">
          {id} | {quoteRequestDetails?.organization?.title}
        </h3>
        <div className="d-flex align-items-center">
          <div className="cursor-pointer">
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 0 }}
              overlay={
                <Tooltip id="bottom-tooltip">
                  {intl.formatMessage({
                    id: "quote-request.loadTemplate",
                    defaultMessage: "Load Template",
                  })}
                </Tooltip>
              }
            >
              <TemplateIcon onClick={() => setShowReuseFormModal(true)} className="mr-2" />
            </OverlayTrigger>
          </div>
          <div className="cursor-pointer">
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 0 }}
              overlay={
                <Tooltip id="bottom-tooltip-export">
                  {intl.formatMessage({
                    id: "quote-request.importRequest",
                    defaultMessage: "Import request",
                  })}
                </Tooltip>
              }
            >
              <ImportIcon />
            </OverlayTrigger>
          </div>
        </div>
      </div>
    </>
  );
}
